import { useState } from "react";
import { testingAxios, testingAuthHeaders } from "@/services/testing";

// ─── Mid-run clarification prompt ─────────────────────────────────────────────

export function ClarificationPrompt({
	runId, failingLabel, suggestion, selectedPlanId,
}: { runId: string; failingLabel: string; suggestion: string; selectedPlanId: string }) {
	const [answered, setAnswered] = useState(false);
	const [custom, setCustom] = useState("");
	const [showCustom, setShowCustom] = useState(false);
	async function respond(answer: string) {
		if (answered) return;
		setAnswered(true);
		try { await testingAxios.post(`/api/plans/${selectedPlanId}/clarify`, { run_id: runId, answer }, { headers: testingAuthHeaders() }); } catch { /**/ }
	}
	if (answered) return null;
	return (
		<div className="rounded-md border border-primary/40 bg-primary/5 p-3 text-xs">
			<div className="mb-1.5 flex items-center gap-1.5">
				<span className="relative flex h-2 w-2 shrink-0"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary opacity-60" /><span className="relative inline-flex h-2 w-2 rounded-full bg-primary" /></span>
				<span className="font-semibold text-foreground">Run paused — need clarification</span>
			</div>
			<p className="mb-2 text-muted-foreground">
				I couldn't find <span className="font-mono text-foreground">"{failingLabel}"</span> — found <span className="font-mono text-primary">"{suggestion}"</span> instead. Is that right?
			</p>
			{showCustom ? (
				<div className="flex gap-1.5">
					<input type="text" value={custom} onChange={(e) => setCustom(e.target.value)} placeholder="Enter the correct name…" className="flex-1 rounded border border-input bg-card px-2 py-1 text-xs outline-none focus:ring-1 focus:ring-ring" onKeyDown={(e) => { if (e.key === "Enter" && custom.trim()) void respond(custom.trim()); }} />
					<button type="button" className="rounded bg-primary px-2 py-1 text-[11px] font-medium text-primary-foreground" onClick={() => custom.trim() && void respond(custom.trim())}>Use this</button>
				</div>
			) : (
				<div className="flex flex-wrap gap-1.5">
					<button type="button" className="rounded bg-primary px-2 py-1 text-[11px] font-medium text-primary-foreground" onClick={() => void respond(suggestion)}>Yes, use "{suggestion}"</button>
					<button type="button" className="rounded border border-border bg-card px-2 py-1 text-[11px] hover:bg-muted/40" onClick={() => setShowCustom(true)}>Different name</button>
					<button type="button" className="rounded border border-border bg-card px-2 py-1 text-[11px] hover:bg-muted/40" onClick={() => void respond("skip")}>Skip step</button>
				</div>
			)}
		</div>
	);
}
